// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@stoneage/Overrides/Components/ProductCompareCarousel";
import { css } from "styled-components";
import { color, ellipsis } from "@stoneage/XDL/Utilities";
import { fontConfig } from "@stoneage/XDL/constants";

carouselStyles.attributeLabelText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.medium,
    color: "common.white",
    css: css`
        display: block;
        width: 100%;
        padding: 12px 10px;
        background: ${color("common.ui7")};
        margin-bottom: 0;
    `,
};

carouselStyles.attributeCarousel = {
    container: {
        css: css`
            padding: 0;
        `,
    },
};

carouselStyles.attributeValuesContainer = {
    css: css`
        padding: 12px 10px;
    `,
};

carouselStyles.attributeValueText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
    `,
};
